/** A fraction (0.07) as a percentage string ("7%") without floating-point noise; up to two decimals. */
export const formatRatePercent = (rate: number): string => `${Math.round((rate * 100 + Number.EPSILON) * 100) / 100}%`;
